import React from 'react'
import AddNewSupplier from './AddNewSupplier';
import AddBreadCrumb from './AddBreadCrumb';
function AddSupplierPage() {
    return ( 
        <div className = "container-fluid">
        <AddBreadCrumb />
        <AddNewSupplier />
        </div>
     );
}

export default AddSupplierPage;